document.addEventListener("click", function (e) {
  const tab = e.target.closest("[data-product-tabs] .product-tabs__tab");
  if (!tab) return;

  const wrap = tab.closest("[data-product-tabs]");
  const id = tab.getAttribute("data-tab");

  // activate tabs
  wrap.querySelectorAll(".product-tabs__tab").forEach((btn) => {
    const active = btn === tab;
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-selected", active ? "true" : "false");
    if (active) btn.setAttribute("aria-current", "true");
    else btn.removeAttribute("aria-current");
  });

  // activate panels
  wrap.querySelectorAll(".product-tabs__panel").forEach((panel) => {
    const active = panel.getAttribute("data-tab-panel") === id;
    panel.classList.toggle("is-active", active);
  });
});
